export enum VOLUME_DISCOUNT_UNITS {
  PERCENT = 'P',
  PESOS = 'C'
};
